<template>
    <div v-if="!loading">
        <template v-if="Array.isArray(journey.actualStages) && journey.actualStages.length">
            <shipping-information
                :positions="journey.actualStages"
                :condition="order.condition"
                :waiting-tasks="order.waitingTasks"
                :index-begin="journey.stageIndexBegin || 0"
                :index-end="journey.stageIndexEnd || 999"
                disabled />

            <optimize-waiting-time-tag
                ref="optimizeWaitingTimeRef"
                class="w-full py-5" />
        </template>
        <template v-else>
            <p>
                Hiện tại chưa có kế hoạch thực tế
            </p>
        </template>
    </div>
</template>
<script lang="ts" setup>
import ShippingInformation from '@/pages/trucker-[id]/order/ignore/shipping-information.vue'
import OptimizeWaitingTimeTag from '@/pages/trucker-[id]/order/ignore/optimize-waiting-time/index.vue'
const props = defineProps({
  journey: {
    type: Object,
    required: true
  },
  order: {
    type: Object,
    required: true
  },
  editable: Boolean
})
const emits = defineEmits(['update:editable', 'change'])
const { journey, order, editable } = toRefs(props)
const optimizeWaitingTimeRef = ref()
onMounted(() => {
  if (!journey.value.actualStages) {
    return
  }
  setTimeout(() => {
    showOptimize()
  }, 500)
})
onBeforeUnmount(() => {
  optimizeWaitingTimeRef.value?.close()
})

const showOptimize = () => {
  if (order.value) {
    const { actualStages, actualShippingPlan, actualOptimalWaitingTime } = journey.value
    const { solution } = order.value

    if (solution !== 'manualPlanning') {
      optimizeWaitingTimeRef.value?.show(actualStages, actualShippingPlan?.[actualShippingPlan?.length - 1], actualOptimalWaitingTime)
    } else {
      optimizeWaitingTimeRef.value?.close()
    }
  }
}

const loading = ref(false)
const refresh = () => {
  loading.value = true
  setTimeout(() => {
    loading.value = false
    setTimeout(() => {
      showOptimize()
    }, 500)
  }, 300)
}
defineExpose({ refresh })
</script>
